import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';


import * as cartConstants from '../cartConstants';
import * as cartUtils from '../cartUtils';
import * as styleUtils from '../../../../utils/styleUtils';

import useAddCartItems from '../hooks/useAddCartItems';
import useRemoveCartItems from '../hooks/useRemoveCartItems';
import {cartSelectors} from '../index';
import {I18nMessage} from '../../I18n';
import {Icon, iconConstants} from '../../../global/Icon';
import {isViewingUser} from '../../Auth';

import styles from './AddToCart.scss';


function AddToCart({isDisabled, item}) {

    const itemId = cartUtils.itemIdFromData(item);
    const cartId = useSelector(cartSelectors.getActiveCartId);
    const {formatMessage} = useIntl();

    /**
     * @type {object|null}
     */
    const cartItem = useSelector(state => cartSelectors.getCartItem(state, cartId, itemId));
    const isInCart = !!cartItem;

    const addCartItems = useAddCartItems();
    const removeCartItems = useRemoveCartItems();

    if (isViewingUser()) {

        return null;
    }

    return (
        <div
            aria-label={formatMessage({id: `cart.addTo.button.${isInCart ? 'remove' : 'add'}.label`})}
            className={styleUtils.toClasses(styles.addToCart, 'action-button')}
            onClick={async event => {

                event.preventDefault();
                event.stopPropagation();

                if (isDisabled) {

                    return;
                }

                if (isInCart) {

                    return await removeCartItems(cartId, [item]);
                }

                await addCartItems(cartId, [item]);
            }}
        >
            <span
                className={
                    styleUtils.toClasses(
                        styles.wrap,
                        isInCart ? styles.isInCart : null,
                        isDisabled ? styles.isDisabled : null
                    )
                }
            >
                <Icon
                    icon={
                        isInCart
                            ? iconConstants.ICON_MINUS
                            : iconConstants.ICON_CART
                    }
                />
                <span className={styles.label}>
                    <I18nMessage id={`cart.addTo.button.${isInCart ? 'remove' : 'add'}.label`}/>
                </span>
            </span>

        </div>
    );
}


AddToCart.propTypes = {
    isDisabled: PropTypes.bool.isRequired,
    item: PropTypes.shape(cartConstants.SHAPE_ADD_TO_CART_ITEM_CONTENT).isRequired
};

AddToCart.defaultProps = {
    isDisabled: false,
    quantity: 1
};


export default AddToCart;
